import React from "react";
import { Page, Document, Image, StyleSheet } from "@react-pdf/renderer";
import InvoiceTitle from "./InvoiceTitle";
import BillTo from "./BillTo";
import InvoiceNo from "./InvoiceNo";
import InvoiceItemsTable from "./InvoiceItemsTable";
import InvoiceThankYouMsg from "./InvoiceThankYouMsg";
import SignatureField from "./SignatureField";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 74,
    height: 66,
    marginLeft: "auto",
    marginRight: "auto",
  },
});

const PurchaseOrder = ({ invoice }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image
        style={styles.logo}
        src="https://iware.info/wp-content/uploads/2017/12/cropped-cropped-iware_trasparent-1.png"
      />
      <InvoiceTitle title={invoice.title} />
      <InvoiceNo invoice={invoice} />
      <BillTo invoice={invoice} />
      <InvoiceItemsTable invoice={invoice} />
      <InvoiceThankYouMsg />
      <SignatureField />
    </Page>
  </Document>
);

export default PurchaseOrder;

// import React from "react";
// import { Page, Document, Image, StyleSheet } from "@react-pdf/renderer";
// import InvoiceTitle from "./InvoiceTitle";
// import BillTo from "./BillTo";
// import InvoiceNo from "./InvoiceNo";
// import InvoiceItemsTable from "./InvoiceItemsTable";
// import InvoiceThankYouMsg from "./InvoiceThankYouMsg";

// const styles = StyleSheet.create({
//   page: {
//     fontFamily: "Helvetica",
//     fontSize: 11,
//     paddingTop: 30,
//     paddingLeft: 60,
//     paddingRight: 60,
//     lineHeight: 1.5,
//     flexDirection: "column",
//   },
//   logo: {
//     width: 74,
//     height: 66,
//     marginLeft: "auto",
//     marginRight: "auto",
//   },
// });

// const PurchaseOrder = ({ invoice }) => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <InvoiceTitle title="Invoice" />
//       <InvoiceNo invoice={invoice} />
//       <BillTo invoice={invoice} />
//       <InvoiceItemsTable invoice={invoice} />
//       <InvoiceThankYouMsg />
//     </Page>
//   </Document>
// );

// export default PurchaseOrder;
